// Copyright (c) StrangeBee 2023

import { PatternType } from '@Constants/patternsRoute';

const mapPermissionRouteRoot: Record<string, PatternType> = {
    manageOrganisation: 'administration.organizations',
    manageProfile: 'administration.profiles',
    manageCustomField: 'administration.customFields',
    // manageAnalyzerTemplate: '',
    manageObservableTemplate: 'administration.observables',
    managePlatform: 'administration.license',
    manageTaxonomy: 'administration.taxonomies',
    managePattern: 'administration.attackPatterns',
};

export const findDefaultPath = (permissions: string[], mapPermissionRoute = mapPermissionRouteRoot): PatternType => {
    const find = Object.keys(mapPermissionRoute).find((s: string) => permissions.includes(s));
    if (find) {
        return mapPermissionRoute[find];
    }
    return 'cases.default';
};
